var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInoxLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    transform: "rotate(-180 20 20)",
    fill: "#234B9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 14.1667L14.1701 19.9965L19.9999 25.8264L21.677 24.1493L18.7222 21.1944H25.9895V18.7986L18.7222 18.7986L21.677 15.8438L19.9999 14.1667ZM19.9999 4.0243C22.1828 4.0243 24.2459 4.44358 26.1892 5.28212C28.1324 6.12066 29.8295 7.26531 31.2803 8.71615C32.7311 10.167 33.8758 11.864 34.7144 13.8073C35.5529 15.7506 35.9722 17.8137 35.9722 19.9965C35.9722 22.206 35.5529 24.2824 34.7144 26.2257C33.8758 28.169 32.7311 29.8594 31.2803 31.2969C29.8295 32.7344 28.1324 33.8724 26.1892 34.7109C24.2459 35.5495 22.1828 35.9688 19.9999 35.9688C17.7904 35.9688 15.714 35.5495 13.7708 34.7109C11.8275 33.8724 10.1371 32.7344 8.6996 31.2969C7.2621 29.8594 6.12408 28.169 5.28554 26.2257C4.44699 24.2824 4.02772 22.206 4.02772 19.9965C4.02772 17.8137 4.44699 15.7506 5.28554 13.8073C6.12408 11.864 7.2621 10.167 8.6996 8.71615C10.1371 7.26531 11.8275 6.12066 13.7708 5.28212C15.714 4.44358 17.7904 4.0243 19.9999 4.0243ZM19.9999 6.42014C16.2199 6.42014 13.0121 7.74448 10.3767 10.3932C7.74127 13.042 6.42356 16.2431 6.42356 19.9965C6.42356 23.7766 7.74127 26.9844 10.3767 29.6198C13.0121 32.2552 16.2199 33.5729 19.9999 33.5729C23.7534 33.5729 26.9545 32.2552 29.6032 29.6198C32.252 26.9844 33.5763 23.7766 33.5763 19.9965C33.5763 16.2431 32.252 13.042 29.6032 10.3932C26.9545 7.74448 23.7534 6.42014 19.9999 6.42014Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInoxLeft);
export default __webpack_public_path__ + "static/media/inox-left.2181d21cb3dfa7d0e98fb30b5515f10a.svg";
export { ForwardRef as ReactComponent };